import styled from "@emotion/styled";
import { Flex } from "@radix-ui/themes";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";

import { Icon } from "@components/Icon";
import { theme } from "@themes/themes";

import { Button, Text } from "@src/ui-kit";
import { Sheet } from "@src/ui-kit/Sheet";

export const MobileMenu: React.FC = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const MenuTabs = [
    {
      label: t("menu.trade"),
      link: "/trades",
      isExternal: false,
      disabled: false,
    },
    {
      label: t("menu.portfolio"),
      link: "/portfolio",
      isExternal: false,
      disabled: false,
    },
    {
      label: t("menu.leaderboard"),
      link: "/leaderboard",
      isExternal: false,
      disabled: false,
    },
    {
      label: t("menu.stats"),
      link: "/stats",
      isExternal: false,
      disabled: false,
    },
    {
      label: t("menu.competitions"),
      link: "/competitions/live",
      isExternal: false,
      disabled: true,
    },
  ];

  const handleRoute = (link: string, isExternal: boolean) => {
    if (isExternal) {
      window.open(link, "_blank");
    } else {
      navigate(link);
      setOpen(false);
    }
  };

  return (
    <>
      <Button
        aria-label={open ? t("menu.closeMenu", "Close menu") : t("menu.openMenu", "Open menu")}
        style={{ width: 32, height: 32 }}
        variant="classic"
        onClick={() => setOpen(!open)}
      >
        <Icon color="accent-contrast" icon={open ? "ri-close-large-line" : "ri-menu-line"} size={12} />
      </Button>

      <Sheet open={open} fullScreenOnly onOpenChange={setOpen}>
        <MenuContent align="center" direction="column" gap="16px">
          <MenuSection align="center" direction="column" gap="0">
            {MenuTabs.map((tab, index) => {
              const isActive = !tab.disabled && !tab.isExternal && location.pathname.includes(tab.link);
              return (
                <React.Fragment key={index}>
                  <MenuButtonWrapper>
                    <MenuButton
                      size="3"
                      variant={isActive ? "outline" : "soft"}
                      onClick={() => !tab.disabled && handleRoute(tab.link, tab.isExternal)}
                      disabled={tab.disabled}
                      style={tab.disabled ? { opacity: 0.5, cursor: "not-allowed" } : undefined}
                    >
                      <Flex align="center" gap="8px" justify="center" width="100%">
                        <Text font="button">{tab.label}</Text>
                        {tab.isExternal && <Icon icon="ri-external-link-line" size={16} />}
                      </Flex>
                    </MenuButton>
                  </MenuButtonWrapper>
                  {index < MenuTabs.length - 1 && <Divider />}
                </React.Fragment>
              );
            })}
          </MenuSection>
        </MenuContent>
      </Sheet>
    </>
  );
};

const MenuContent = styled(Flex)`
  padding: 20px;
  height: 100%;
`;

const MenuSection = styled(Flex)`
  width: 100%;
`;

const MenuButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  width: 100%;
`;

const MenuButton = styled(Button)`
  width: 200px;
  justify-content: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.color("gray-5")};
`;
